$('.owl-carousel').each(function() {
  const $carousel = $(this);
  const itemCount = $carousel.find('.item').length;

  if (itemCount === 1) {
    // Single image: use OwlCarousel for responsiveness but disable autoplay/loop/dots
    $carousel.owlCarousel({
      center: true,
      loop: false,
      autoplay: false,
      margin: 20,
      dots: false,
      nav: false,
      responsive: {
        0: { items: 1 },
        400: { items: 1 },
        600: { items: 2 },
        1000: { items: 3 }
      }
    });
  } else if (itemCount === 2) {
    $carousel.owlCarousel({
      loop: false,
      autoplay: false,
      margin: 20,
      dots: false,
      nav: false,
      responsive: {
        0: { items: 1 },
        400: { items: 1 },
        600: { items: 2 },
        1000: { items: 3 }
      }
    });
  } else {
    // 3+ images - use full carousel features
    $carousel.owlCarousel({
      center: true,
      loop: true,
      autoplay: true,
      margin: 20,
      dots: true,
      nav: false,
      // stagePadding: 50,
      responsive: {
        0: { items: 1 },
        400: { items: 1 },
        600: { items: 2 },
        1000: { items: 3 }
      }
    });
  }
});